module.exports = __webpack_public_path__ + "img/lines.980a2e6a.svg";